/* eslint-disable @typescript-eslint/ban-ts-comment */
import React, { useState, useMemo } from 'react';
import { Box } from '@mui/material';
import Table from 'molecules/Table';
import { StyledCellText2 } from 'molecules/Table/styles/Text.styles';
import { neutrals } from 'utils/styles/color';

const CompanyReports = () => {
  const [companyProjects] = useState<{ month: string; type: string }[]>([
    { month: 'August', type: 'EasyOps' },
    { month: 'September', type: 'EasyOps' },
    { month: 'October', type: 'SPA' },
    { month: 'November', type: 'SPA' },
  ]);

  const columns = useMemo(
    () => [
      {
        key: 'month',
        label: 'Month',
        sortable: false,
        width: '50%',
        render: (report: { month: string }) => (
          <StyledCellText2>{report?.month || ''}</StyledCellText2>
        ),
      },
      {
        key: 'type',
        label: 'Type',
        sortable: false,
        width: '50%',
        render: (report: { type: string }) => (
          <StyledCellText2>{report?.type || ''}</StyledCellText2>
        ),
      },
    ],
    []
  );

  return (
    // <CloudOpsCard>
    //   <CardHeader
    //     title={
    //       <Stack className="custom-header">
    //         <Typography variant="h6">Reports</Typography>
    //       </Stack>
    //     }
    //     avatar={<CardAvatar />}
    //   />
    //   <CardContent sx={{ padding: '24px 8px' }}>

    //   </CardContent>
    // </CloudOpsCard>
    <Box
      sx={{
        maxHeight: '275px',
        overflow: companyProjects.length > 6 ? 'hidden scroll' : 'hidden',
        paddingRight: '5px',
        '.MuiTableHead-root .MuiTypography-root': {
          color: neutrals[500],
        },
      }}
    >
      <Table
        stickyHeader
        emptyText=""
        idKey="id"
        size="small"
        hover={false}
        columns={columns}
        data={companyProjects}
      />
    </Box>
  );
};

export default CompanyReports;
